module.exports = __webpack_public_path__ + "static/media/szrmb.46baa7eb.png";